import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import { fetchShiftbats } from "./shiftbatsAPI";
import { catchAllErrors } from "../../hoc/catchAllErrors";

export const fetchShiftbatsAsync = createAsyncThunk("shiftbats/fetchShiftbats", async (userId) => {
    try {
        const response = await catchAllErrors(fetchShiftbats)(userId);
        return response;
    } catch (error) {
        toast("Failed to fetch driver duties", { type: "error" });
        throw error;
    }
});

export const shiftbatsSlice = createSlice({
    name: "shiftbats",
    initialState: {
        shiftbats: null,
        document: null,
        meta: {},
        status: "idle",
        error: null,
    },
    reducers: {
        setShiftbats: (state, action) => {
            state.shiftbats = action.payload;
        },
        setDocument: (state, action) => {
            state.document = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchShiftbatsAsync.pending, (state) => {
                state.shiftbats = [];
                state.status = "pending";
            })
            .addCase(fetchShiftbatsAsync.fulfilled, (state, action) => {
                state.shiftbats = action.payload;
                state.status = "fulfilled";
            })
            .addCase(fetchShiftbatsAsync.rejected, (state, action) => {
                state.shiftbats = [];
                state.status = "rejected";
                state.error = action.error.message;
            })
    },
});

export const { setShiftbats, setDocument } = shiftbatsSlice.actions;

export const selectShiftbats = (state) => state.shiftbats.shiftbats;

export const selectDocument = (state) => state.shiftbats.document;

export default shiftbatsSlice.reducer;
